/**
 * Per-option "Add to cart" for the duration (length of wear) selector (mobile).
 * Each .duration-card__atc points the main product form's hidden variant id at
 * its own variant, then submits the form via requestSubmit() so it runs through
 * the theme's product-form (AJAX add + cart drawer).
 */
if (!window.__durationAddBound) {
  window.__durationAddBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.duration-card__atc');
    if (!button || button.disabled) return;

    var form = document.getElementById(button.getAttribute('data-form'));
    if (!form) return;

    var idInput = form.querySelector('.product-variant-id');
    if (idInput) {
      idInput.removeAttribute('disabled');
      idInput.value = button.getAttribute('data-variant-id');
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });
}
